var typography = {
    h1: {
        fontFamily: 'Bebas Neue',
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "72px",
        lineHeight: "74px",
        textTransform: "uppercase",
    },
    h2: {
        fontFamily: 'Bebas Neue',
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "60px",
        lineHeight: "48px",
        textTransform: "uppercase",
    },
    h3: {
        fontFamily: 'Bebas Neue',
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "48px",
        lineHeight: "48px",
        textTransform: "uppercase",
    },
    h4: {
        fontFamily: 'Bebas Neue',
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "32px",
        lineHeight: "32px",
        textTransform: "uppercase",
    },
    h5: {
        fontFamily: 'Bebas Neue',
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "24px",
        lineHeight: "32px",
        textTransform: "uppercase",
    },
    section: {
        fontFamily: 'Montserrat',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "22px",
        letterSpacing: "0.02em",
        textTransform: "uppercase",
    },
    podnaslovL: {
        fontFamily: 'Montserrat',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "24px",
        lineHeight: "29px",
        letterSpacing: "-0.014em",
        textTransform: "uppercase",
    },
    podnaslovM: {
        fontFamily: 'Montserrat',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "20px",
        lineHeight: "29px",
        letterSpacing: "-0.014em",
        textTransform: "uppercase",
    },
    podnaslovS: {
        fontFamily: 'Montserrat',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "22px",
    },
    podnaslovXS: {
        fontFamily: 'Montserrat',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "17px",
        textTransform: "uppercase",
    },
    podnaslovXS1: {
        fontFamily: 'Montserrat',
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "14px",
        lineHeight: "normal",
        letterSpacing: "-0.196px",
        textTransform: "uppercase",
    },
    podnaslovXSmale: {
        fontFamily: 'Montserrat',
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "18px",
        letterSpacing: "0.28px",
        textTransform: "lowercase",
    },
    bodyXL: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "18px",
        lineHeight: "33px",
    },
    bodyL: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "33px",
    },
    bodyM: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "16px",
    },
    bodyS: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "14px",
    },
    bodyXLBold: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "33px",
    },
    bodyLBold: {
        /* Body L bold */
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "33px",
    },
    bodyMBold: {
        /* Body M bold */
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "16px",
    },
    bodySBold: {
        /* Body S bold */
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "12px",
        lineHeight: "14px",
    },
    bodyMobile: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "20px",
        lineHeight: "31px",
    },
    podnapis: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "10px",
        lineHeight: "12px",
        letterSpacing: "0.04em",
    },
    meni: {
        fontFamily: 'Montserrat',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "18px",
        letterSpacing: "0.02em",
        textTransform: "uppercase",
    },
    gumbL: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: "0.02em",
        textTransform: "uppercase",
    },
    gumbS: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.24px",
        textTransform: "uppercase",
    },
    gumbSthin: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "18px",
        textTransform: "uppercase",
    },
    bodyNaslovBold: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "23px",
        lineHeight: "33px",
    },
    bodyNaslovBoldUppercase: {
        fontFamily: 'Source Sans Pro',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "23px",
        lineHeight: "33px",
        textTransform: "uppercase",
    },
    podSliko: {
        fontFamily: 'Montserrat',
        fontStyle: "italic",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "15px",
    }
};
export default typography;
